import React, { useEffect, useRef, useState } from 'react';
import {IncidentManagementScreen} from '../screens/incident-management/ui/screens/IncidentManagementScreen';
export default function ManagmentConfiguration() {

    return (
        <div>
           <IncidentManagementScreen></IncidentManagementScreen>
        </div>
    );
}